var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltipText,
    classes: 'new-tooltip',
  }),expression:"{\n    content: tooltipText,\n    classes: 'new-tooltip',\n  }"}],class:_vm.css()},[_c('AtomIcon',{attrs:{"name":"bulb-2","size":13,"color":"var(--color-canary)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }